import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ClashDetectionDetails, ClashSettings } from "@ServerTypes/clashDetections/clashDetections.schema";

interface ClashDetailsState extends ClashDetectionDetails {
  isFetch: boolean;
  settings?: ClashSettings;
}

const clashDetailsSlice = createSlice({
  name: "clashDetails",
  initialState: { isFetch: false } as ClashDetailsState,
  reducers: {
    setClashDetails: (_state: ClashDetailsState, action: PayloadAction<ClashDetectionDetails>) => ({
      ...action.payload,
      isFetch: true,
    }),
    setClashSettings: (_state: ClashDetailsState, action: PayloadAction<Partial<ClashSettings>>) => ({
      ..._state,
      settings: { ..._state?.settings, ...action.payload },
    }),
    resetClashDetails: (_state: ClashDetailsState, _action: PayloadAction<void>) => ({ isFetch: false }),
  },
});

export const { setClashDetails, setClashSettings, resetClashDetails } = clashDetailsSlice.actions;

export const clashDetails = clashDetailsSlice.reducer;

export default {
  clashDetails,
};
